export default {
  "iso3": "spa",
  "iso2": "es",
  "text": {
    "100200": "Lo sentimos, parece que este juego se encuentra restringido en tu zona.",
    "CURRENT_LANGUAGE": "Español",
    "CIP8_TITLE": "JUEGOS DE 888CASINO",
    "Login": "INICIAR",
    "WITHDRAW": "RETIRAR",
    "CASHIER": "Cajero",
    "Search": "Busca tu juego...",
    "REWARDS": "Premios",
    "HOME": "Inicio",
    "888_COM": "888.com",
    "888_POKER": "poker",
    "888_CASINO": "casino",
    "888_BINGO": "bingo",
    "888_SPORT": "sport",
    "SIGN_UP": "REGÍSTRATE",
    "DEPOSIT_SIDE_MENU": "Deposita",
    "MY_ACCOUNT": "Mi Cuenta",
    "BALANCE": "Tu saldo",
    "LOGOUT": "Cerrar sesión",
    "GREETING_MORNING": "Buenos días",
    "GREETING_AFTERNOON": "Buenas tardes",
    "GREETING_EVENING": "Buenas tardes",
    "GREETING_NIGHT": "Buenas noches",
    "GREETING_DEFAULT": "Hola",
    "MRS_TITLE": "Sra.",
    "MR_TITLE": "Sr.",
    "SLOTS": "Tragamonedas",
    "LOBBY": "Lobby",
    "SLOTS_JACKPOTS": "Slots y Botes",
    "CARD_TABLE_GAMES": "Juegos de mesa y cartas",
    "CASINO_GAMES": "Juegos de Casino",
    "LIVE_CASINO": "Casino en Vivo",
    "PROMOTIONS": "Promociones",
    "VIP_CLUB": "VIP Club",
    "PWA_INSTALL": "Instalar App",
    "PWA_ADD_TO_HOME_SCREEN": "Añadir a la pantalla de inicio",
    "PWA_TAP": "Pulsa",
    "PWA_QUICK_LAUNCH": "Lanzamiento rápido de {BRAND}",
    "BLOG": "Blog",
    "TODAY_WINNERS": "Ganadores de hoy",
    "SUPPORT_ID_MESSAGE": "N.º de asistencia",
    "DEPOSIT": "DEPOSITA",
    "CHOOSE_LANG": "Elige tu idioma:",
    "CHOOSE_COUNTRY": "Elige tu país:",
    "SIGN_IN_PLAY": "INICIA SESIÓN Y JUEGA",
    "NEW": "Nuevo",
    "JACKPOT": "Bote",
    "BRAND_EXCLUSIVE_FILTER": "Exclusivo de {brandName}",
    "EXCLUSIVE": "Exclusivo de 888",
    "SI_EXCLUSIVE": "Exclusivo de SI",
    "1-25_LINES": "De 1 a 25 líneas",
    "25+_LINES": "25+ líneas",
    "888_EXCLUSIVE_GAMES": "Juegos exclusivos de 888",
    "INFO_TITLE_ARENA_888_EXCLUSIVE_GAMES": "¡Juegos de casino exclusivos!",
    "INFO_TEXT_ARENA_888_EXCLUSIVE_GAMES": "888casino posee una selección de juegos de casino exclusivos. Tenemos las slots online de la Section8 con las que puedes disfruta de juegos de casino fantásticos como la Ruleta online y el Blackjack en tu móvil. Nuestros juegos de casino exclusivos también incluyen todo tipo de juegos de ruleta en sus diferentes versiones y un numeroso repertorio de juegos de tragaperras online de las más populares. ¡Preparaos para pasarlo bien jugando al casino!",
    "INFO_TITLE_ARENA_SLOTS": "Tragamonedas online",
    "INFO_TEXT_ARENA_SLOTS": "Elige entre los más de 100 mejores juegos de tragamonedas online desde donde quieras. Disfruta de numerosas funciones como los juegos de bonus, los comodines expansibles, los giros gratis y enormes pozos. ¿Quieres encontrar un tesoro en el antiguo Egipto, buscar el cofre de oro del duende o prefieres la versión clásica? Sea cual sea la temática que te guste, ¡seguro que encontraremos tu juego favorito!",
    "INFO_TITLE_ARENA_CASINO": "Juegos de casino",
    "INFO_TEXT_ARENA_CASINO": "Se barajan las cartas, se gira la ruleta y tu asiento está esperándote. Juega solo a los mejores juegos de cartas y de mesa online. Elige entre numerosos juegos de ruleta, como la europea, la americana, de apuestas bajas, de apuestas altas y Super Stakes. ¿Prefieres el Blackjack? Juega varias manos a la vez. Desde Texas Hold’em hasta Caribbean, ¡seguro que encontraremos el poker que más te gusta!",
    "INFO_TITLE_ARENA_ROULETTE": "Ruleta",
    "INFO_TEXT_ARENA_ROULETTE": "La modalidad más interactiva de juego la encontrarás en la ruleta en vivo de 888casino gracias al streaming en tiempo real de mesas de ruleta con crupieres de carne y hueso. Retransmitidas desde un casino real, las sesiones de la ruleta en vivo ofrecen a nuestros jugadores una experiencia auténticamente realista, trasladándolos al ambiente de los casinos reales desde las mesas de juego virtuales.",
    "INFO_TITLE_ARENA_NEW_GAMES": "Juegos Nuevos",
    "INFO_TEXT_ARENA_NEW_GAMES": " ",
    "INFO_TITLE_ARENA_BLACKJACK": "Blackjack Online",
    "INFO_TEXT_ARENA_BLACKJACK": "¡Las cartas están listas y tu asiento te espera para uno de los mejores juegos de blackjack online que encontrarás! Juega al blackjack en 888casino con tus propias condiciones y Super Stakes, apuestas complementarias y mucho más. ¿Una mano de blackjack no es suficiente para ti? ¡Juega a nuestro juego Multihand Blackjack para obtener tres posibilidades de conseguir 21, simultáneamente!",
    "INFO_TITLE_ARENA_VIDEO_POKER": "Video Poker Online",
    "INFO_TEXT_ARENA_VIDEO_POKER": "¡Si crees que eres un verdadero experto en el poker, entonces has venido al casino indicado! Intenta conseguir esa Escalera Real que tanto se te resiste en nuestros distintos tipos de juegos de video poker. Si te gusta el poker tapado con 5 cartas o si prefieres el clásico Texas Hold’em, seguro que encontrarás tu nuevo juego favorito de video poker online en 888casino.",
    "INFO_TITLE_ARENA_SCRATCH_CARDS": "Tarjetas de rascar online",
    "INFO_TEXT_ARENA_SCRATCH_CARDS": "No hay nada como una victoria rápida en uno de los emocionantes juegos de rasca y gana de 888casino. Ideal para una estrategia divertida y totalmente gratuita; elige una tarjeta de rascar online con la temática que desees. Puedes desvelar tus riquezas irlandesas o descubrir tu fortuna faraónica; de ti depende. ¡Simplemente elige la cantidad que quieres apostar y comprueba si eres el ganador de una tarjeta de rascar!",
    "NETENT_SLOTS": "TRAGAMONEDAS NETENT",
    "BONUS": "Bonus",
    "FREE_SPINS": "Giros gratis",
    "CLEAR_ALL": "Borrar todo",
    "FILTER": "Filtro",
    "APPLY": "Aplicar",
    "ROULETTE": "Ruleta",
    "BLACKJACK": "Blackjack",
    "BACCARAT": "BACARÁ",
    "POKER": "Poker",
    "KENO": "Keno",
    "HIGH_LIMIT": "High Limit",
    "LANGUAGES": "Idiomas",
    "HELP": "Ayuda",
    "LIVE_CHAT": "Chat en vivo",
    "DEMO": "Demo",
    "PLAY": "Juega",
    "NOT_NOW": "Ahora no",
    "MAYBE_LATER": "Ahora no",
    "NO_THANKS": "No, gracias",
    "LETS_PLAY": "¡Vamos a jugar!",
    "GOT_IT": "GOT IT!",
    "LIMITS": "Límites",
    "LIVE": "En vivo",
    "SEE_ALL": "Ver todo",
    "WINNING_IN_THE_LAST_30_DAYS": "Ganancias en los últimos 30 días",
    "TOTAL_JACKPOTS": "Pozos totales",
    "TOP_GAMES": "LOS MEJORES JUEGOS DE TRAGAMONEDAS",
    "LIVE_CASINO_TABLES": "MESAS EN VIVO SELECCIONADAS",
    "JACKPOTS": "POZOS",
    "RECENTLY_PLAYED": "Juegos recientes",
    "BECAUSE_YOU_PLAYED": "Porque has jugado {gameName}",
    "MINIMUM_BET": "Apuesta mín.",
    "MAXIMUM_BET": "Apuesta máx.",
    "PAYLINES": "Líneas de pago",
    "BONUS_GAME": "Juego de bonus",
    "MAX_PER_SPOT": "Máx. por espacio",
    "MULTIPLAYER": "Multijugador",
    "DECKS": "Barajas",
    "SIDE_BETS": "Apuestas complementarias",
    "ABOUT": "Acerca de",
    "GAME_JACKPOT": "Pozo del juego",
    "SLOT_GAMES": "Slots",
    "CARD_AND_TABLE_GAMES": "Juegos de mesa y cartas",
    "JACKPOT_GAMES": "Juegos de pozos acumulados",
    "JACKPOT_CENTRAL": "Central de juegos con Bote",
    "OTHER": "Otro",
    "POKER_GAMES": "JUEGOS DE POKER",
    "YOUR_SEARCH_DID_NOT_MATCH_ANY_GAMES": "Tu búsqueda no coincide con ningún juego",
    "PREMIER_ONLINE_LIVE_CASINO": "El mejor Live Casino",
    "All_SLOTS": "Todas las tragamonedas",
    "All_CARD_AND_TABLE_GAMES": "Todos los juegos de mesa y cartas",
    "USEFUL_LINKS": "Enlaces útiles",
    "PRIVACY_POLICY": "Política de privacidad",
    "USER_AGREEMENT": "Acuerdo con el usuario",
    "RESPONSIBLE_GAMBLING": "Juego responsable",
    "SAFE_ZONE": "Centro de control",
    "CONTACT": "Contacto",
    "COMP_POINTS": "PUNTOS DE PREMIOS",
    "HISTORY": "Historial",
    "GAMING_HISTORY": "Historial de juego",
    "TIPPING_HISTORY": "Historial de propinas",
    "TIPPING_HISTORY_AMOUNT": "Importe de las propinas",
    "GAMING_SESSION_HISTORY": "Historia de las sesiones",
    "TOP_CASINO_GAMES": "LOS MEJORES JUEGOS DE CASINO",
    "MY_CHALLENGES": "My Challenges",
    "SCRATCHCARDS": "Tarjetas de Rascar",
    "QUICK_LINKS_TITLE": "ENLACES RÁPIDOS",
    "NO_SEARCH_RESULTS": "No se han encontrado resultados de búsqueda...",
    "SEARCH_YOUR_GAME": "Juegos, temas y desarrolladores",
    "SEARCH_RESULTS_TITLE": "PRINCIPALES RESULTADOS DE BÚSQUEDA",
    "SUGGESTED_GAMES": "JUEGOS SUGERIDOS",
    "SUGGESTED_CATEGORIES": "CATEGORÍAS SUGERIDAS",
    "BACK": "Atrás",
    "OUR_JACKPOTS": "NUESTROS POZOS",
    "MY_CLUB": "Mi club",
    "CASH_BALANCE": "Saldo de efectivo",
    "BONUS_BALANCE": "Saldo de bonus",
    "HIT_THE_JACKPOT": "Consigue el pozo",
    "YOU_MAY_LIKE": "PUEDE QUE TE GUSTE",
    "TOP_PICKS_FOR": "LA MEJOR SELECCIÓN PARA {USERNAME}",
    "888CLUB": "888club",
    "888POKER": "888poker",
    "888SPORT": "888sport",
    "BACK_TO_888POKER": "Volver a 888poker",
    "BACK_TO_888SPORT": "Volver a 888sport",
    "VIDEO_POKER_GAMES": "Juegos de Vídeo Poker",
    "VIDEO_POKER": "Video Poker",
    "SEO_IMAGE_CATEGORIES_TITLE": "La mejor experiencia de {categoryName} en 888casino",
    "SEO_IMAGE_CATEGORIES_ALT": "casino online: {categoryName}",
    "SEO_IMAGE_GAME_TITLE": "{gameName} {categoryName}",
    "LOW_ROLLERS": "Low Rollers",
    "NETENT": "NETENT",
    "TOP_NETENT_SLOTS": "MEJORES SLOTS DE NETENT",
    "PLAY_50_FREESPINS": "JUEGA 50 GIROS GRATIS",
    "HOLIDAY_GAMES": "JUEGOS NAVIDEÑOS",
    "ELITE_LOUNGE": "Elite Lounge",
    "ORIGINALS": "888 Originales",
    "RELATED_GAMES": "PORQUE HAS SELECCIONADO: {gameName}",
    "DAILY_JACKPOT_GAMES": "Jackpot Games diarios",
    "HIGH_VOLATILITY": "Volatilidad alta",
    "LOW_VOLATILITY": "Volatilidad baja",
    "IN_HOUSE_SLOTS": "Slots internas",
    "MORE_GAMES": "Más juegos",
    "CLASSIC_SLOTS": "SLOTS CLÁSICAS",
    "ALL_JACKPOTS": "TODOS LOS BOTES",
    "POPULAR_GAMES_TITLE": "Juegos populares",
    "MORE": "Más",
    "GAMES": "Juegos",
    "HOMEPAGE-SPOOKY_SPINS": "Spooky Spins",
    "THE_DAILY_JACKPOT": "BOTE DIARIO DE 888",
    "HIGH_NOON_JACKPOT": "Bote de mediodía",
    "TWILIGHT_JACKPOT": "Bote de la noche",
    "POWER8_JACKPOT": "BOTE POWER 8",
    "RED_TIGER_DAILY_JACKPOT": "POZO DIARIO DE RED TIGER",
    "RED_TIGER_HOURLY_JACKPOT": "Pozo diario de Red Tiger",
    "PROGRESSIVE_JACKPOTS": "POZOS ACUMULADOS",
    "INFO_TITLE_ARENA_JACKPOTS": "Pozos",
    "INFO_TEXT_ARENA_JACKPOTS": "Diviértete jugando en los juegos de 888casino. Cada uno tiene una temática diferente. Ponte en la piel de un pirata y podrás comenzar la búsqueda del tesoro o enfrentarte a Freddy Krueger en Elm Street. Los juegos son muy variados y divertidos y cada uno te ofrece sus características particulares con distintas bonificaciones, jugadas gratis y lo más importante: espectaculares botes acumulados.  Elige tu juego favorito, comienza a jugar y llévate el bote. ¡Buena suerte!",
    "INSTANT_GAMES": "Juegos Con Ganancias Inmediatas",
    "INSTANT_WIN_GAMES_ARENA": "Juegos Con Ganancias Inmediatas",
    "ALL_INSTANT_WIN_GAMES": "TODOS LOS JUEGOS CON GANANCIAS INMEDIATAS",
    "INFO_TITLE_ARENA_INSTANT_WIN_GAMES": "Juegos instantáneos",
    "INFO_TEXT_ARENA_INSTANT_WIN_GAMES": "Los juegos con premios instantáneos son los más DIVERTIDOS. Prepárate para rascar y ganar en los mejores juegos del mercado. Tenemos una amplia oferta de juegos para ti como Volcano Eruption, Panda Mania y Merlin’s Millions. ¿No dispones de mucho tiempo? No te preocupes, prueba el Keno, el Bingo o las últimas novedades como Chicken Extreme, 7-UP y Epic Gems.",
    "TRENDING_SLOTS": "SLOTS DE MODA",
    "EXCLUSIVE_LIVE_TABLES": "MESAS EXCLUSIVAS EN DIRECTO ",
    "BLACKJACK_AND_ROULETTE_GAMES": "JUEGOS DE RULETA Y BLACKJACK",
    "ALL_888_EXCLUSIVE_GAMES": "TODOS LOS JUEGOS EXCLUSIVOS DE 888",
    "LIVE_ARENA_TABLE_IS_CLOSED_MESSAGE": "La mesa abre a las",
    "LIVE_CASINO_TABLE_FULL_PC": "Mesa completa",
    "LIVE_CASINO_TABLE_FULL_MOBILE": "Completa",
    "GAME_SHOWS": "Juegos en vivo",
    "TOP_EVO_GAMES": "Los mejores juegos",
    "FOR_YOU_GAMES": "PARA TI",
    "AB_TEST_AI_LIST_TITLE_D1_V1": "Juegos mejor valorados para {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D1_V2": "Juegos recomendados para {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V1": "Juegos seleccionados para {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V2": "Juegos elegidos para {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V3": "Juegos exclusivos para {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V4": "Juegos recomendados para ti",
    "LETS_PLAY_MONOPOLY": "Juguemos al Monopoly",
    "TOP_TRENDING_SLOTS": "Las slots de moda",
    "TOP_PAYING_SLOTS": "Las slots más lucrativas",
    "RECENTLY_ADDED": "Añadidas recientemente",
    "TOP_SLOTS": "Las slots más populares",
    "VIRTUAL_SPORTS": "Virtual Sports",
    "INFO_TITLE_ARENA_VIRTUAL_SPORTS": "Virtual Sports",
    "INFO_TEXT_ARENA_VIRTUAL_SPORTS": "Virtual Sports te trae una gran variedad de juegos deportivos generados por ordenador en los que podrás apostar las 24 horas del día. Entonces… ¿Por qué esperar al gran juego de esta noche cuando puedes apostar en nuestros juegos virtuales ahora?",
    "MINI_ORBIT_BALANCE": "Saldo:",
    "REAL_MONEY_GAME": "Solo se puede jugar a este juego con tu saldo de efectivo.",
    "NEW_GAMES_LIST_TITLE": "Nuevos juegos de casino online",
    "NEW_GAMES": "Nuevos Juegos",
    "TOP_EXCLUSIVE_SLOTS": "Las tragaperras más exclusivas",
    "TOP_10_IN_YOUR_COUNTRY": "Las 10 mejores del país",
    "CANT_CONNECT_ERROR_TITLE": "No se puede conectar",
    "CANT_CONNECT_ERROR_MESSAGE": "Lo sentimos, ha habido un problema.",
    "RETRY": "VUELVE A INTENTARLO",
    "ALL_CIP_GAMES": "TODOS LOS JUEGOS",
    "TRANSACTION_HISTORY": "Historial de transacciones",
    "HOTTEST_NEW_GAMES": "Los mejores juegos nuevos",
    "BRAND_NEW": "Novedad",
    "SINCE_LAST_MONTH": "Desde el mes pasado",
    "FROM_LAST_MONTH": "From Last Month",
    "SAFE_GAMBLING_TOOLTIP": "Información y herramientas de juego más seguro",
    "GAME_POPUP_GAME_UNAVAILABLE": "Lo siento, este juego no está disponible.",
    "GAME_POPUP_MAY_LIKE": "También te puede interesar:",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE": "¡HURRA! ¡El juego de {partyJackpotName} está a punto de comenzar!",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE_ALL_LIVE_CASINO": "LUCKY YOU!",
    "PARTY_JACKPOT_WELCOME_POPUP_SUB_TITLE_ALL_LIVE_CASINO": "All Live Casino games are part of our HOT NEW jackpot!",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION": "Puedes ganar el pozo con cualquier apuesta del saldo de efectivo.\nTodos los premios de los pozos de fiesta son bonus que se ingresarán en tu cuenta de inmediato.",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL": "¡Cualquier apuesta con dinero real en un juego con pozo de fiesta podría ganar un premio en efectivo!\n¡El pozo de fiesta concede ganancias a diario!",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY": "Any real money bet on a Party Jackpot game could win a cash prize!\nThe Party Jackpot will pay hourly between {startHour} to {endHour}",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY_ALL_LIVE_CASINO": "Real money bets on any Live Casino game could win the jackpot! The Live Casino Jackpot must pay every hour, {startHour} - {endHour}, and is fully funded by us.",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE": "Bonus: apuesta 30 veces (varía según el juego), 90 días de validez, ganancias limitadas a $500, válido para juegos seleccionados",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE_REAL": "Solo jugadores con fondos",
    "PARTY_JACKPOT_WELCOME_POPUP_TERMS_AND_CONDITIONS_APPLY": "Sujeto a términos y condiciones.",
    "PARTY_JACKPOT_WIN_TOASTER_TITLE": "¡Ha salido el {jackpotName} de {winAmount}!",
    "PARTY_JACKPOT_WIN_TOASTER_SUBTITLE": "¿No has ganado? ¡No te preocupes!\n Este Bote sale cada hora, de {startHour} a {endHour}.",
    "PARTY_JACKPOT_WIN_POPUP_YOU_WON": "HAS GANADO EL {jackpotName}",
    "PARTY_JACKPOT_WIN_POPUP_AWESOME": "¡GENIAL!",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_TITLE": "Recarga para jugar por el Bote de Live Casino",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_SUBTITLE": "El Bote de Live Casino solo se puede ganar con dinero real",
    "JACKPOT-WIDGET-MUST-PAY": "Debe pagarse durante:",
    "JACKPOT-WIDGET-DROPS-SOON": "¡TOCARÁ PRONTO!",
    "JACKPOT-WIDGET-STARTS-SOON": "¡EMPIEZA PRONTO",
    "JACKPOT-WIDGET-NEXT-JACKPOT": "El lanzamiento del próximo pozo",
    "JACKPOT-WIDGET-LAST-WIN": "Última ganancia",
    "IN-GAME-WIDGET-STARTS-SOON": "Empieza pronto",
    "FREEPLAY_INDICATOR": "Jugada gratis",
    "OMG_INDICATOR": "Notificaciones",
    "USER_LIKE_YOU": "PUESTO {topNumber} EN {countryName}",
    "YOUR_COUNTRY": "Tu país",
    "CLOSE": "Cerrar",
    "LIVE_STREAM_WATCH_TIME_REACHED": "¿Deseando entrar a jugar?",
    "LIVE_STREAM_VIDEO_LOADING": "Cargando…",
    "PLAY_NOW": "JUEGA AHORA",
    "CASINO": "CASINO",
    "PAYMENTS_REDIRECT_FOCUS_TITLE": "Procesando depósito",
    "PAYMENTS_REDIRECT_FOCUS_TEXT": "Tu pantalla {mftName} sigue abierta",
    "PAYMENTS_REDIRECT_FOCUS_CTA": "Continuar",
    "VOLATILE_SLOTS": "Tragaperras con volatilidad",
    "VOLATILE_GAMES": "Juegos volátiles",
    "HIGH_VOLATILITY_SLOTS": "Tragaperras de gran volatilidad",
    "LOW_VOLATILITY_SLOTS": "Tragaperras de baja volatilidad",
    "BURNOUT_MESSAGE_LINE_1": "SURPRISE!",
    "BURNOUT_MESSAGE_LINE_2": "YOU GOT A BONUS!",
    "CONGRATS": "¡Enhorabuena!",
    "YOUR_FP_ARE_WAITING": "Tus Jugadas Gratis te está esperando aquí",
    "EXIT_POPUP_TITLE": "Puede Que También Te Guste",
    "DONT_SHOW_AGAIN_TEXT": "No volver a mostrar",
    "GAMING_HISTORY_NO_RECORDS": "No hemos podido ubicar ningún registro de historial de tus juegos",
    "GAMING_HISTORY_LAST_PAGE": "No se han encontrado más registros de historial.",
    "GAMING_HISTORY_BET": "Apuesta",
    "GAMING_HISTORY_WINNINGS": "Ganancias",
    "GAMING_HISTORY_WINNINGS_BONUS_CAP": "Ganancias*",
    "GAMING_HISTORY_BANKROLL": "Cuenta",
    "GAMING_HISTORY_MORE_DETAILS": "Más detalles",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_PC": "Solo disponible en dispositivos móviles",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_MOBILE": "Solo disponible en ordenadores",
    "GAMING_HISTORY_FREE_PLAY_BET": "Apuesta*",
    "GAMING_HISTORY_FREE_PLAY_WINNINGS": "Ganancias*",
    "GAMING_HISTORY_FREE_PLAY_REWARD_WINNINGS": "Ganancias de premios",
    "GAMING_HISTORY_FREE_PLAY_REWARD_BANKROLL": "Cuenta de premios",
    "GAMING_HISTORY_FREE_PLAY_INDICATION": "*Jugada con premios",
    "GAMING_HISTORY_FREE_PLAY_MAX_CUP_INDICATION": "*Ganancia máxima",
    "GAMING_HISTORY_DAYS_INTERVAL": "Últimos {numberOfDays} días",
    "GAME_SESSION_ID": "Identificación de sesión {sessionID}",
    "HISTORY_GAME_SESSION_TOTAL_BETS": "Total de Apuestas",
    "HISTORY_GAME_SESSION_TOTAL_WINNINGS": "Ganacias Totales",
    "HISTORY_GAME_SESSION_BALANCE": "Balance de la Sesion",
    "GAME_WINDOW_VENDOR_SESSION_ID": "Identificación de sesión {sessionID}",
    "GAME_WINDOW_MODE_REAL_LABEL": "Jugar por dinero",
    "GAME_WINDOW_MODE_DEMO_LABEL": "Práctica",
    "FREE_PLAY_VOUCHER_NAME_FPV": "FreePlay",
    "FREE_PLAY_VOUCHER_NAME_FSV": "Giros gratis",
    "FREE_PLAY_VOUCHER_NAME_JPFPV": "FreePlay de Bote",
    "FREE_PLAY_VOUCHER_NAME_JPFSV": "Giros de pozo",
    "FREE_PLAY_VOUCHER_BALANCE_PREFIX": "Restante:",
    "FREE_PLAY_VOUCHER_TITLE_FPV": "Premio de FreePlay",
    "FREE_PLAY_VOUCHER_TITLE_FSV": "Premio de giros gratis",
    "FREE_PLAY_VOUCHER_TITLE_JPFPV": "Premio de FreePlay de pozo",
    "FREE_PLAY_VOUCHER_TITLE_JPFSV": "Premio de giros de pozo",
    "FREE_PLAY_VOUCHER_DESC_FPV": "Dinero de FreePlay que puedes usar como quieras en juegos seleccionados.",
    "FREE_PLAY_VOUCHER_DESC_FSV": "Dinero de giros gratis con valores predefinidos que puedes usar en juegos seleccionados.",
    "FREE_PLAY_VOUCHER_DESC_JPFPV": "Dinero de FreePlay exclusivo del pozo que puedes usar como quieras en juegos seleccionados.",
    "FREE_PLAY_VOUCHER_DESC_JPFSV": "Giros gratis exclusivos del pozo con valores predeterminados que puedes usar en juegos seleccionados.",
    "FREE_PLAY_VOUCHER_REWARD_AMOUNT": "{amount} {fp_voucher_name}",
    "FREE_PLAY_VOUCHER_REWARD_BALANCE": "{fp_voucher_remaining_prefix} {balance}",
    "FREE_PLAY_EXPIRES_IN_TIME": "Vence el {expiration}",
    "FREE_PLAY_EXPIRES_IN_EXPIRED": "Vencido",
    "FREE_PLAY_EXPIRES_IN_DAY": "Vence en {expiration} días",
    "FREE_PLAY_MESSAGE_VOUCHER_TITLE_GOOD_LUCK": "¡Buena suerte!",
    "FREE_PLAY_MESSAGE_LIST_TITLE": "Hay recompensas esperándote. ¡Buena suerte!",
    "FREE_PLAY_MESSAGE_SELECTED_GAME_TITLE": "Este juego también puede jugarse con los siguientes premios:",
    "FREE_PLAY_MESSAGE_GAMES_LIST_TITLE": "Puedes utilizar este premio en los siguientes juegos.",
    "FREE_PLAY_MESSAGE_NO_VOUCHERS": "No tienes premios disponibles",
    "FREE_PLAY_MESSAGE_BACK_TO_VOUCHERS": "Atrás",
    "FREE_PLAY_SHOW_MORE": "Mostrar Más",
    "FREE_PLAY_SHOW_LESS": "Mostrar Menos",
    "FREE_PLAY_USE_NOW_BUTTON": "Usar ahora",
    "FREE_PLAY_USE_LATER_BUTTON": "Usar después",
    "FREE_PLAY_SUGGESTION_DIALOG_TITLE": "¡Tienes recompensas en este juego!",
    "IDLE_RECOMMENDATIONS_TITLE": "¿No sabes qué juego elegir?",
    "IDLE_RECOMMENDATIONS_SECOND_TITLE": "Este podría gustarte: ",
    "BONUS_ABUSE_PREVENTION_TITLE": "Partida desconectada",
    "BONUS_ABUSE_PREVENTION_MESSAGE": "Parece que se ha desconectado una partida...\nFinalice {gameName} antes de comenzar a jugar {newGameName}.",
    "BONUS_ABUSE_PREVENTION_NOT_NOW_BTN": "Ahora no",
    "BONUS_ABUSE_PREVENTION_COMPLETE_BTN": "Partida finalizada",
    "OPEN_GAME_FROM_CHALLENGES": "Los retos no se pueden completar utilizando recompensas.",
    "CANCEL": "Cancelar",
    "YES": "SÍ",
    "NO": "NO",
    "ONE_GAME_PER_SESSION_DIALOG_TITLE": "Juego abierto",
    "ONE_GAME_PER_SESSION_DIALOG_MESSAGE": "Parece ser que todavía hay un juego abierto…\n ¿Quieres cerrar {oldGameName} y comenzar a jugar a {newGameName}?",
    "GAMES_OF_THE_WEEK": "Games Of The Week",
    "THE_FISH_MARKET": "The Fish Market",
    "LETS_PLAY_POKER": "Lets Play Poker!",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_TITLE": "Conexión lenta",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_SUBTITLE": "Se detectó que la conexión es lenta. La apertura del juego tardará algo más de lo previsto.",
    "HYBRID_EMBEDDED_GAME_LOADING_SPINNER_LABEL": "Conectando...",
    "HYBRID_EMBEDDED_GAME_LOADING_PACKAGES_PROGRESS": "Preparando juego {packagesStatus}",
    "HELP_CENTER": "Centro de Ayuda",
    "ABOUT_TITLE": "Datos de tu cuenta",
    "ABOUT_SUPPORT_ID_TITLE": "Identificador para obtener ayuda",
    "ABOUT_FISCAL_CODE_TITLE": "Código fiscal",
    "ABOUT_CLIENT_VERSION_TITLE": "Versión del cliente",
    "ABOUT_HELP_SUPPORT": "Para preguntas de asistencia, visita nuestra ayuda en línea",
    "ABOUT_OPEN_SESSION_TITLE": "Saldo de la sesiones abiertas",
    "ES_GAME_LIMIT_REGULATORY_TEXT": "En 888casino.es apoyamos y promovemos {responsibleGamblingLink} y te ofrecemos las herramientas para controlar tanto el tiempo que juegas como el dinero que apuestas. Antes de empezar a jugar, configura tu sesión en función de tus preferencias",
    "ES_GAME_LIMIT_RESPONSIBLE_GAMING_LINK": "el juego responsable",
    "ONE_HOUR": "1 hora",
    "X_HOURS": "{x} horas",
    "ONE_MINUTE": "1 minuto",
    "X_MINUTES": "{x} minutos",
    "ONE_DAY": "1 día",
    "X_DAYS": "{x} días",
    "ONE_WEEK": "1 semana",
    "ONE_MONTH": "1 mes",
    "ADVANCED_MODE": "Modo avanzado",
    "SELECT": "Selecciona",
    "DONT_WANT_TO_BE_BLOCKED": "No quiero ser bloqueado",
    "START_PLAYING": "Comienza a jugar",
    "ES_GAME_LIMIT_RESTRICTION_PERIOD_VALUE": "Bloquearme por {time}",
    "ES_GAME_LOSS_LIMIT_VALUE": "{percent}% de la cuenta ({loss})",
    "ES_TIME_LIMIT_DROP_DOWN_LABEL": "Límite máximo de duración",
    "ES_LOSS_LIMIT_DROP_DOWN_LABEL": "Límite máximo de perdidas",
    "ES_REMINDER_INTERVAL_DROP_DOWN_LABEL": "Intervalo de recordatorio",
    "ES_RESTRICTION_PERIOD_DROP_DOWN_LABEL": "Al alcanzar mis límites:",
    "ES_GAME_TIME_LIMIT_REQUIRED_ERROR": "Selecciona un límite de tiempo",
    "ES_GAME_LOSS_LIMIT_REQUIRED_ERROR": "Selecciona un límite de pérdida",
    "ES_GAME_LIMIT_TIME_LOSS_CONFIRMATION_TEXT": "Ten en cuenta que tu tiempo máximo de juego en esta sesión es de {time}.",
    "ES_GAME_LIMIT_TIME_LOSS_CONFIRMATION_QUESTION": "¿Deseas continuar?",
    "ES_GAME_LIMIT_RESTRICTION_BLOCK_CONFIRMATION_TEXT": "Has especificado un tiempo de bloqueo de {time}. Esto significa que, una vez que alcanzas los límites que has definido, no podrás volver a jugar durante el tiempo especificado.",
    "ES_GAME_LIMIT_RESTRICTION_BLOCK_CONFIRMATION_QUESTION": "¿Estás seguro?",
    "ES_GAME_LIMIT_TITLE": "Configura tu sesión de juego",
    "GAMBLING_SESSION_SETUP_TITLE": "Inicia tu sesión",
    "GAMBLING_SESSION_MESSAGE": "Nota: la sesión sólo se aplica a todos los juegos de casino y a las partidas de cash de póquer",
    "GAMBLING_SESSION_WARN_MESSAGE": "LOS LÍMITES SE RESTABLECEN UNA VEZ ALCANZADOS O AL VOLVER A INICIAR SESIÓN",
    "GAMBLING_SESSION_START": "Iniciar sesión",
    "GAMBLING_SESSION_LAST_BET": "Última apuesta: {lastBetDate}",
    "GAMBLING_SESSION_TIME_LIMIT_REQUIRED_ERROR": "Límite de tiempo de la sesión no establecido",
    "GAMBLING_SESSION_LOSS_LIMIT_REQUIRED_ERROR": "Límite de pérdida de sesión no establecido",
    "GAMBLING_SESSION_LIMIT_REGULATORY_TEXT": "Apoyamos y promovemos el  {responsibleGamblingLink}, y ponemos a disposición las herramientas para apoyar el juego sostenible. El abuso del juego puede tener un efecto negativo en tu vida, provocando adicción, dificultades económicas y la ruptura de relaciones.",
    "GAMBLING_SESSION_LIMIT_RESPONSIBLE_GAMING_LINK": "juego seguro",
    "GAMBLING_SESSION_REMINDER_INTERVAL_DROP_DOWN_LABEL": "Recordatorios de la sesión",
    "GAMBLING_SESSION_LOSS_LIMIT_VALUE": "{percent}% de la cuenta ({loss})",
    "GAMBLING_SESSION_LOSS_LIMIT_DROP_DOWN_LABEL": "Límite de pérdidas de sesión",
    "GAMBLING_SESSION_LIMIT_RESTRICTION_PERIOD_VALUE": "Bloquearme por {time}",
    "GAMBLING_SESSION_LIMIT_RESTRICTION_BLOCK_CONFIRMATION_TEXT": "Has especificado un tiempo de bloqueo de {time}. Esto significa que, una vez que alcanzas los límites que has definido, no podrás volver a jugar durante el tiempo especificado.",
    "GAMBLING_SESSION_LIMIT_RESTRICTION_BLOCK_CONFIRMATION_QUESTION": "¿Estás seguro?",
    "GAMBLING_SESSION_RESTRICTION_PERIOD_DROP_DOWN_LABEL": "Cuando termine mi sesión",
    "GAMBLING_SESSION_LIMIT_TIME_LOSS_CONFIRMATION_TEXT": "Ten en cuenta que tu tiempo máximo de juego en esta sesión es de {time}.",
    "GAMBLING_SESSION_LIMIT_TIME_LOSS_CONFIRMATION_QUESTION": "¿Deseas continuar?",
    "GAMBLING_SESSION_TIME_LIMIT_DROP_DOWN_LABEL": "Límite de sesión",
    "GAMBLING_SESSION_TIME_LIMIT_REACHED_TITLE": "Limite de tiempo alcanzado",
    "GAMBLING_SESSION_LOSS_LIMIT_REACHED_TITLE": "Limite de pérdidas alcanzado",
    "GAMBLING_SESSION_INTERVAL_REMINDER_TITLE": "Recordatorios de tiempo de juego",
    "GAMBLING_SESSION_TIME_LIMIT_REACHED_TEXT": "A las {gamblingSessionLimitTimestamp} has alcanzado tu limite de tiempo en esta sesión",
    "GAMBLING_SESSION_LOSS_LIMIT_REACHED_TEXT": "A las {gamblingSessionLimitTimestamp} has alcanzado tu limite de pérdidas en esta sesión",
    "GAMBLING_SESSION_INTERVAL_REMINDER_TEXT": "A las {gamblingSessionLimitTimestamp} has alcanzado tu Recordatorios de tiempo de juego en esta sesión.",
    "GAMBLING_SESSION_DATA_DURATION": "Duración de la sesión:",
    "GAMBLING_SESSION_DATA_WIN_LOSS_SUMMARY": "Resumen de ganancias y pérdidas:",
    "GAMBLING_SESSION_DATA_TOTAL_BETS": "Apuestas totales:",
    "GAMBLING_SESSION_ADVANCED_WARN_LOSS_LIMIT_TOAST": "Tu Límite de pérdidas está a punto de alcanzarse",
    "GAMBLING_SESSION_ADVANCED_WARN_TIME_LIMIT_TOAST": "Tu Límite de tiempo está a punto de alcanzarse",
    "GAMBLING_SESSION_LOGOUT_DIALOG_TITLE": "Cerrar sesion",
    "GAMBLING_SESSION_SELF_RESTRICTION_MESSAGE": "Te has impuesto una restricción para jugar juegos de casino adicionales hasta las {restrictionExpirationDate}.",
    "GAMBLING_SESSION_LIMITS_ALREADY_SET": "Límites de sesión ya establecidos",
    "ATTENTION": "¡Aviso!",
    "TOTAL_BANKROLL": "Banca:",
    "GAME_SESSION_BALANCE": "Saldo de la sesión:",
    "TOTAL_WINS": "Ganancias totales:",
    "TOTAL_BETS": "Apuestas totales:",
    "ES_SESSION_TIME_LIMIT_MESSAGE": "Vas a alcanzar el tiempo máximo de juego. Puedes terminar la sesión.",
    "ES_INTERVAL_REMINDER_MESSAGE": "Juegas durante {timePassed}, tus apuestas totales ascienden a {totalBets} y tus ganancias totales a {totalWins}",
    "ES_SESSION_LOSS_LIMIT_MESSAGE": "Vas a alcanzar el presupuesto máximo. Puedes terminar la sesión.",
    "GAME_SESSION_SUMMARY_DIALOG_TITLE": "La sesión ha finalizado",
    "GAME_SESSION_SUMMARY_DIALOG_MESSAGE": "Tu sesión de {game_name} ha finalizado\n\nApuestas totales: {total_bets_amount}\n\nGanancias totales: {total_wins_amount}",
    "OK": "Aceptar",
    "INSUFFICIENT_FUNDS_TITLE": "Saldo insuficiente",
    "INSUFFICIENT_FUNDS_MESSAGE": "Tu saldo actual no es suficiente para este juego. Para continuar jugando, tienes que depositar fondos primero en el cajero.",
    "OPEN_CASHIER": "Abrir cajero",
    "GAME_LIMIT_REAL_MONEY_WARNING_MESSAGE": "Solo se puede jugar a este juego con tu saldo de efectivo.",
    "SUGGEST_REAL_MODE_DIALOG_TITLE": "Juego de demostración",
    "SUGGEST_REAL_MODE_DIALOG_TEXT": "Recuerda que {game_name} se abrirá en modo de demostración.<br><br>Para jugar por dinero real, regístrate o inicia sesión.",
    "PLAY_DEMO": "Jugar demostración",
    "GAME_NET_POSITION_LABEL": "Saldo",
    "GAME_DURATION_LABEL": "Duración del juego",
    "Adventure": "Aventuras",
    "Ancient Civilization": "Civilizaciones antiguas",
    "Arabic": "Árabe",
    "Asian": "Asiática",
    "Classic Style": "Estilo clásico",
    "Comics and Cartoons": "Cómics y dibujos animados",
    "Diamonds and Gems": "Diamantes y gemas",
    "Egyptian": "Egipcia",
    "Fantasy and Folklore": "Fantasía y folclore",
    "Farm and Pets": "Granjas y mascotas",
    "Fish": "Peces",
    "Fruit and Candy": "Frutas y caramelos",
    "Greek Mythology": "Mitología griega",
    "Irish": "Irlandesa",
    "Money and Leisure": "Dinero y ocio",
    "Movies and Music": "Cine y música",
    "Seasonal": "Estacional",
    "Space and Sci-fi": "Espacio y ciencia ficción",
    "Wildlife": "Vida salvaje",
    "GAME_STUDIOS": "Game studios",
    "THEMES": "Temas",
    "GAME_FEATURES": "Características",
    "GAME_CATEGORIES": "Categorías",
    "FILTER_BY": "Filtrar por",
    "NO_JACKPOT": "Sin pozo",
    "HIGH_STAKES": "Apuestas grandes",
    "LOW_STAKES": "Apuestas bajas",
    "MULTIHAND": "Manos múltiples",
    "LIVE_BACCARAT": "Baccarat en vivo",
    "LIVE_POKER": "Poker en vivo",
    "LIVE_GAME_SHOWS": "Shows de partidas en vivo",
    "CRAPS": "Craps",
    "LIVE_ROULETTE": "Ruleta en vivo",
    "MEDIUM_VOLATILITY": "Volatilidad media",
    "VOLATILITY": "Volatilidad",
    "ARENA_WITHOUT_FILTER": "Casino en Vivo",
    "SPEED_GAMES": "Juegos Rapido",
    "generic_notification_popup_title": "Notificación",
    "MDP_INACTIVITY_DISCONNECTED_TEXT": "Debido a la falta de actividad, has quedado desconectado.",
    "RICH_USER_NOT_LOGGED_IN": "Inicia sesión para ver tus retos",
    "temp_account_title": "Asegura tu cuenta",
    "temp_account_days_left": "Días Restantes",
    "temp_account_upload_btn": "CARGAR DOCUMENTOS",
    "MENU_ITEM_ABOUT": "Acerca de",
    "MENU_ITEM_GAMING_SESSION_HISTORY": "Historia de las sesiones",
    "MENU_ITEM_GAMING_REMINDERS": "Recordatorio de tiempo de juego",
    "MENU_ITEM_TOUCH_ID": "Inicio Biométrico",
    "MENU_ITEM_INACTIVITY_TIMEOUT_SETTINGS": "Configuración",
    "MENU_ITEM_HYBRID_INFO": "Información",
    "MENU_ITEM_CASHIER_VERIFY_ID": "Verificación de identidad",
    "TOUCH_ID_SUB_CAPTION": "Esta función se habilitará en tu próximo inicio de sesión",
    "TOUCH_ID_CAPTION": "Puedes iniciar sesión más rápido usando la funciones Táctil/Face ID de tu dispositivo.",
    "TERMS_AND_CONDITIONS": "Términos y condiciones",
    "TOUCH_ID_INIT_SCREEN_ENABLE_BUTTON": "ACTIVAR",
    "TOUCH_ID_AUTO_SCREEN": "INICIO DE SESIÓN CON TOUCH/FACE ID",
    "kick_reason_general": "La sesión de tu cuenta se ha cerrado",
    "kick_reason_20": "Tu sesión se ha cerrado porque has iniciado sesión desde otra ubicación",
    "ONBOARDING_WELCOME_STEP_MAIN_TEXT": "Más juegos. Mayores pozos. Experiencia personalizada.",
    "ONBOARDING_WELCOME_STEP_SECONDARY_TEXT": "¿Listo para explorar tu nuevo hogar?",
    "ONBOARDING_MENU_STEP_MAIN_TEXT": "Este mágico menú te proporcionará TODA la diversión",
    "ONBOARDING_MENU_STEP_SECONDARY_TEXT": "Pozos, tragamonedas, mesas EN VIVO y promociones",
    "ONBOARDING_USER_AREA_MAIN_TEXT": "Controla tu cuenta en un solo lugar",
    "ONBOARDING_USER_AREA_SECONDARY_TEXT": "ID de cuenta, historial de transacciones, resumen de bonus, etc.",
    "NEXT": "Siguiente",
    "DONE": "Listo",
    "TOUCH_ID_INFO": "<li>Si activas la función Touch/Face ID en este dispositivo, cualquier persona cuyas huellas dactilares estén guardadas en este dispositivo podrá acceder a tu cuenta de 888. En el caso de que haya huellas dactilares de más de una persona almacenadas en este dispositivo, no deberías configurar esta opción.</li><li>Al utilizar la función Touch ID para acceder a tu cuenta de 888, aceptas que eres el único responsable de todas las transacciones que se realicen en tu cuenta, independientemente de si esas transacciones han sido realizadas por un tercero o por cualquier persona que haya almacenado su huella dactilar en este dispositivo.</li><li>Además, aceptas que el operador de la aplicación y sus afiliados (juntos, el “Grupo 888”) no serán responsables ante ti de ninguna consecuencia que pueda derivarse del uso de Touch/Face ID para acceder a tu cuenta de 888. El Grupo 888 no será responsable de ninguna pérdida, responsabilidad, daño, perjuicio o gasto ocasionado por el uso de esta función.</li><li>Por cada aplicación de 888 que tengas en tu dispositivo, solo podrás configurar una de tu cuentas para iniciar sesión con Touch/Face ID en cualquier momento.</li><li>Deberás iniciar sesión utilizando tu contraseña cuando la autenticación de Touch/Face ID no funcione o venza.</li><li>El Grupo 888 no almacena tus huellas dactilares en sus servidores y no gestiona ni presta apoyo a la tecnología Touch/Face ID.</li>",
    "TABLE_GAMES": "Juegos de mesa",
    "ARCADE": "Arcade",
    "SPORTS": "Deportes",
    "SCRATCH_CARDS": "Tarjetas Rasca",
    "MEXICAN": "Mexicano",
    "BINGO": "Bingo",
    "CLASSIC_STYLE_MODERNIZED": "Estilo clásico modernizado",
    "AZTEC_INCA_MAYAN": "Aztecas, incas y mayas",
    "CRIME": "Crimen",
    "WILD_WEST": "Salvaje oeste",
    "CANDY_AND_SWEETS": "Caramelos y dulces",
    "GOLD_MINING": "Minería de oro",
    "VIKINGS_AND_NORDIC_MYTHOLOGY": "Vikingos y mitología nórdica",
    "XMAS": "Navidad",
    "LAST_LOGIN_TITLE": "Último inicio de sesión:",
    "LIVE_SLOTS": "Live Slots",
    "THE_BOOK_SHELF": "The Book Shelf",
    "LUCKYTAP_GAMES": "LuckyTap Games",
    "VEGAS_SLOTS": "Vegas Slots",
    "MUSIC_TO_MY_EARS": "Music to my ears",
    "GENIES_JACKPOT": "Genie's Jackpot",
    "NEW_LIVE_CASINO_GAMES": "New Live Casino Games",
    "TSR_WAGERED_AMOUNT": "Importe de la apuesta",
    "TSR_SUBTITLE_MALTA": "¡Mantén el control de tu juego!",
    "TSR_WINNINGS_TEXT": "Tus ganancias totales",
    "TSR_LOSSES_TEXT": "Tus pérdidas totales",
    "TSR_TITLE": "Recordatorio de tiempo consumido",
    "TSR_MENU_LINK_LABEL": "Recordatorio de tiempo consumido",
    "TSR_CONFIRM": "ACEPTAR",
    "TSR_SESSION_TIME_TEXT": "Has iniciado sesión durante:",
    "TSR_CLOSE_GAME": "Cerrar juego",
  }
}